import { AppThunk } from "../store";
import firebase from "../../firebase/config";
import { SignInData } from "../type";
import {
  setLoading,
  setError,
  signOut,
  needVerification,
  setSuccess,
} from "./slice";
export const signinAction =
  (data: SignInData, onError: () => void): AppThunk =>
  async (dispatch) => {
    try {
      // const adminSnapshot = await firebase.firestore().collection("admin").get();
      const adminSnapshot = await firebase.firestore().collection("admin").doc("adminCredentials").get();

      if(adminSnapshot.exists){
        const adminData = adminSnapshot.data();
        if (adminData && adminData.email=== data.email && adminData.password === data.password) {
          // const admin = await firebase
          // .auth()
          // .signInWithEmailAndPassword(data.email, data.password);
          
          dispatch(setSuccess("Login Successfull"));
        }
      }
      onError();
      dispatch(setError("You are not authorized to access the admin panel."));
    } catch (err: any) {
      console.log(err);
      onError();
      dispatch(setError(err.message));
    }
  };
export const setErrorAction =
  (msg: any): AppThunk =>
  async (dispatch) => {
    dispatch(setError(msg));
  };
export const setLoadingAction =
  (value: boolean): AppThunk =>
  (dispatch) => {
    try {
      dispatch(setLoading(value));
    } catch (err: any) {
      console.log(err.message);
    }
  };
export const getUserByIdAction =
  (id: string): AppThunk =>
  async (dispatch) => {
    try {
      const user = await firebase
        .firestore()
        .collection("users")
        .orderBy("name");
      console.log("user", user);
      // if (user.exists) {
      //   const userData = user.data() as User;
      //   dispatch(setUser(userData));
      // }
    } catch (err) {
      console.log(err);
    }
  };
export const signout = (): AppThunk => async (dispatch) => {
  try {
    await firebase.auth().signOut();
    dispatch(signOut());
  } catch (err) {
    console.log("sign out", err);
  }
};
export const setNeedVerification = (): AppThunk => async (dispatch) => {
  dispatch(needVerification);
};
